import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import BatchSub from './BatchSub'
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex',
        color: 'black',
    },
    flexCount: {
        display: 'flex',
        margin: '20px 0'
    },
    count: {
        backgroundColor: '#dc3545',
        color: 'white',
        marginLeft: '5px',
        padding: '0 10px',
        borderRadius: '10px'
    },
    typography: {
        padding: theme.spacing(2),
        backgroundColor: '#fff',
        color: '#303030 !important',
        borderRadius: '5px'
    },
    showOnTop: {
        zIndex: '9999'
    },
    replyColor: { 
        color: '#303030' 
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    tableCellContentFormat: { 
        textAlign: 'center' 
    },
    replyFormat: { 
        textAlign: 'center', 
        width: '90px', 
        whiteSpace: 'nowrap', 
        overflow: 'hidden', 
        textOverflow: 'ellipsis', 
        paddingLeft: '40px', 
        cursor: 'pointer' 
    }
}))

const ColorButton = withStyles((theme) => ({
    root: {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        minWidth: '30px !important',
        marginLeft: '10px'
    },
}))(Button);

function BatchStorage(props) {
    const classes = useStyles();
    const {t} = useTranslation('storageScan');
    const storageManagement = useSelector(state => state.storageScanManagement);
    const batchSendNo = storageManagement.batchSendNo;
    
    const [rows, setRows] = useState([]);
    const [rowsToBeScanned, setRowsToBeScanned] = useState([]);
    const [rowsScanned, setRowsScanned] = useState([]);
    const [rowsDisplayToBeScanned, setRowsDisplayToBeScanned] = useState([]);
    const [rowsDisplayScanned, setRowsDisplayScanned] = useState([]);
    const [rowsFilterReplyToBeScanned, setRowsFilterReplyToBeScanned] = useState([]);
    const [rowsFilterRetriedToBeScanned, setRowsFilterRetriedToBeScanned] = useState([]);
    const [rowsFilterReplyScanned, setRowsFilterReplyScanned] = useState([]);
    const [rowsFilterRetriedScanned, setRowsFilterRetriedScanned] = useState([]);

    // Obtain current specific batch information
    useEffect(() => {
        if(storageManagement.clearingItems.data) {
            setRows(storageManagement.clearingItems.data);
        }
    }, [storageManagement.clearingItems]);
    // Divide batch information into toBeScanned/scanned and reply/retried with their combination
    useEffect(() => {
        let rowsToBeScanned = [];
        let rowsScanned = [];
        let rowsReplyToBeScanned = [];
        let rowsRetriedToBeScanned = [];
        let rowsReplyScanned = [];
        let rowsRetriedScanned = [];
        if(rows.length > 0) {
            for(const row of rows) {
                if(row.is_scanned) {
                    rowsScanned.push(row)
                    if(row.reply) {
                        rowsReplyScanned.push(row)
                    }
                    if(row.retried) {
                        rowsRetriedScanned.push(row)
                    }
                } else {
                    rowsToBeScanned.push(row);
                    if(row.reply) {
                        rowsReplyToBeScanned.push(row)
                    }
                    if(row.retried) {
                        rowsRetriedToBeScanned.push(row)
                    }
                }
            }
            setRowsToBeScanned(rowsToBeScanned);
            setRowsScanned(rowsScanned);
            setRowsDisplayToBeScanned(rowsToBeScanned);
            setRowsDisplayScanned(rowsScanned);
            setRowsFilterReplyToBeScanned(rowsReplyToBeScanned);
            setRowsFilterRetriedToBeScanned(rowsRetriedToBeScanned);
            setRowsFilterReplyScanned(rowsReplyScanned);
            setRowsFilterRetriedScanned(rowsRetriedScanned);
        } else {
            setRowsToBeScanned([]);
            setRowsScanned([]);
            setRowsDisplayToBeScanned([]);
            setRowsDisplayScanned([]);
            setRowsFilterReplyToBeScanned([]);
            setRowsFilterRetriedToBeScanned([]);
            setRowsFilterReplyScanned([]);
            setRowsFilterRetriedScanned([]);
        }
    }, [rows]);

    return (
        <>
            <BatchSub 
                rows={rowsToBeScanned} 
                rowsDisplayTrans={rowsDisplayToBeScanned}
                rowsFilterReplyTrans={rowsFilterReplyToBeScanned}
                rowsFilterRetriedTrans={rowsFilterRetriedToBeScanned}
                batchSendNo={batchSendNo}
                id={'toBeScanned'}
                warehouse={props.warehouse}
            />
            <BatchSub 
                rows={rowsScanned} 
                rowsDisplayTrans={rowsDisplayScanned}
                rowsFilterReplyTrans={rowsFilterReplyScanned}
                rowsFilterRetriedTrans={rowsFilterRetriedScanned}
                batchSendNo={batchSendNo}
                id={'scanned'}
                warehouse={props.warehouse}
            />
        </>
    );
}

export default BatchStorage;